import { createContext } from "react"

/** Undefined renders inline; null suppresses measurement copies or waits for a slot. */
export const FilterBarContext = createContext<
  HTMLDivElement | null | undefined
>(undefined)
